import { CruisePurchaseModel } from 'api-hooks/order/cruise';
import { CruiseSaleModel } from 'api-hooks/sale/cruise';
import { MainAdditionalFormType } from 'legacy-modules/order/ticket-order/components/form-type';
import * as Yup from 'yup';

export const CruisePurchaseGuestItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    guestDetailId: Yup.string(), // just for relation indicator
  });

export const CruisePurchaseDetailsItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    basicFare: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    portCharge: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    tax: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    tipping: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),
    cruiseRoomId: Yup.string().default(''),
    cruiseRoomNumber: Yup.string().default(''),
    deck: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    cruiseRoomName: Yup.string().default(''),
    guestDetailId: Yup.string(), // just for relation indicator
  });

export const CruisePurchaseAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const CruisePurchaseItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    cruiseId: Yup.string().default(''),
    cruiseShipId: Yup.string().default(''),
    startedAt: Yup.date().default(new Date()),
    endedAt: Yup.date().default(new Date()),
    route: Yup.string().default(''),
    isGroupedPrice: Yup.bool().default(false),
    reminder: Yup.bool().default(false),
    bookingCode: Yup.string().default(''),

    cruisePurchaseGuests: Yup.array(
      CruisePurchaseGuestItemFormSchema(),
    ).default([]),

    cruisePurchaseDetails: Yup.array(
      CruisePurchaseDetailsItemFormSchema(),
    ).default([]),

    cruisePurchaseAddOns: Yup.array(CruisePurchaseAddOnsFormSchema()).default(
      [],
    ),

    //additional information
    customId: Yup.string(),
    cruiseName: Yup.string().default(''),
    cruiseShipName: Yup.string().default(''),
  });

export const CruisePurchaseFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    tourRefId: Yup.string(),
    invoiceRefId: Yup.string(),
    agentId: Yup.string().default(''),
    paymentChannelId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    commission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    cruisePurchases: Yup.array(CruisePurchaseItemFormSchema()).default([]),
  });

export type CruisePurchaseGuestItemFormType = Yup.InferType<
  ReturnType<typeof CruisePurchaseGuestItemFormSchema>
>;

export type CruisePurchaseDetailsItemFormType = Yup.InferType<
  ReturnType<typeof CruisePurchaseDetailsItemFormSchema>
>;

export type CruisePurchaseAddOnsItemFormType = Yup.InferType<
  ReturnType<typeof CruisePurchaseAddOnsFormSchema>
>;

export type CruisePurchaseItemFormType = Yup.InferType<
  ReturnType<typeof CruisePurchaseItemFormSchema>
>;

export type CruisePurchaseFormType = Yup.InferType<
  ReturnType<typeof CruisePurchaseFormSchema>
> &
  MainAdditionalFormType & {
    cruiseSale?: CruiseSaleModel;
    cruisePurchase?: CruisePurchaseModel;
  };
